import { useForm } from '@inertiajs/react'
import CommandCenterLayout from '@/frontend/layouts/CommandCenterLayout'

interface Props {
  source_definition_id: string
  expires_at: string
  submitted: boolean
  submit_path: string
  oauth_start_path?: string
  authorize_url?: string
  copy: Record<string, string>
}

function Show({ source_definition_id, expires_at, submitted, submit_path, oauth_start_path, authorize_url, copy }: Props) {
  const form = useForm({ source_auth: { configuration: '{}' } })
  const submit = (oauth: boolean) => {
    const options = { onFinish: () => form.reset() }
    if (oauth && oauth_start_path) form.post(oauth_start_path, options)
    else form.patch(submit_path, options)
  }
  return <section className="mx-auto max-w-2xl space-y-4 p-6">
    <h1 className="text-xl font-semibold">{copy.title}</h1>
    <p>{source_definition_id} · {copy.expires}: {expires_at}</p>
    {submitted && <p role="status">{copy.received}</p>}
    {authorize_url && <p><a className="underline" href={authorize_url} rel="noreferrer">{copy.oauth_continue}</a></p>}
    <form className="space-y-4" onSubmit={(event) => {
      event.preventDefault()
      submit(false)
    }}>
      <label className="block" htmlFor="source-configuration">{copy.configuration}</label>
      <textarea id="source-configuration" autoComplete="off" spellCheck={false} rows={10}
        className="w-full rounded border p-3 font-mono" value={form.data.source_auth.configuration}
        onChange={(event) => form.setData('source_auth', { configuration: event.target.value })} />
      <p>{copy.help}</p>
      <button className="rounded bg-slate-900 px-4 py-2 text-white" disabled={form.processing}>{copy.submit}</button>
      {oauth_start_path && <button type="button" className="ml-3 rounded border px-4 py-2" disabled={form.processing}
        onClick={() => submit(true)}>{copy.oauth_start}</button>}
    </form>
  </section>
}

Show.layout = (page: React.ReactElement) => <CommandCenterLayout>{page}</CommandCenterLayout>
export default Show
